import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase.js';

// Pointage de pause : « Je pars en pause » / « Je reprends ».
// L'heure est posée par le serveur (fonctions prep_pause_debut / prep_pause_fin, script SQL 020).
// Pendant la pause, l'écran est masqué ; un autre utilisateur peut prendre le téléphone via « Changer d'utilisateur »
// (la pause reste ouverte au nom de la personne jusqu'à ce qu'elle reprenne).
const HM = (iso) => new Date(iso).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

export default function PauseButton({ user, onLogout }) {
  const [pause, setPause] = useState(null);     // pause ouverte
  const [ask, setAsk] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [, tick] = useState(0);
  const [indispo, setIndispo] = useState(false); // table absente (script SQL non passé)

  useEffect(() => {
    let alive = true;
    supabase.from('elixir_prep_pauses').select('*').eq('user_id', user.id).is('fin', null).maybeSingle()
      .then(({ data, error }) => { if (!alive) return; if (error) { setIndispo(true); return; } setPause(data || null); });
    const t = setInterval(() => tick((x) => x + 1), 30000);
    return () => { alive = false; clearInterval(t); };
  }, [user.id]);

  if (indispo || ['pharmacien', 'admin'].includes(user.role)) return null;

  async function debut() {
    setBusy(true); setErr('');
    const { data, error } = await supabase.rpc('prep_pause_debut', { p_user_id: user.id, p_user_name: user.name });
    setBusy(false);
    if (error) { setErr('Pause non enregistrée (' + error.message + '). Vérifie le réseau et réessaie.'); return; }
    setPause(data); setAsk(false);
  }
  async function fin() {
    setBusy(true); setErr('');
    const { error } = await supabase.rpc('prep_pause_fin', { p_user_id: user.id });
    setBusy(false);
    if (error) { setErr('Reprise non enregistrée (' + error.message + '). Vérifie le réseau et réessaie.'); return; }
    setPause(null);
  }

  if (pause) {
    const min = Math.max(0, Math.round((Date.now() - new Date(pause.debut)) / 60000));
    return (
      <div style={{ position: 'fixed', inset: 0, zIndex: 9500, background: 'rgba(26,82,118,0.97)', color: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24, textAlign: 'center', gap: 14 }}>
        <div style={{ fontSize: 56 }}>☕</div>
        <div style={{ fontSize: 22, fontWeight: 800 }}>{user.name}, tu es en pause</div>
        <div style={{ fontSize: 16, opacity: 0.9 }}>depuis {HM(pause.debut)} · {min} min</div>
        <button disabled={busy} onClick={fin} style={{ marginTop: 10, background: '#fff', color: '#1A5276', border: 'none', borderRadius: 14, padding: '18px 28px', fontSize: 18, fontWeight: 800, minWidth: 260, cursor: 'pointer' }}>
          {busy ? 'Enregistrement…' : '▶ Je reprends le travail'}
        </button>
        {err && <div style={{ background: '#C0392B', padding: '8px 12px', borderRadius: 8, fontSize: 13, maxWidth: 360 }}>{err}</div>}
        <button onClick={onLogout} style={{ marginTop: 18, background: 'none', border: '1px solid rgba(255,255,255,.5)', color: '#fff', borderRadius: 10, padding: '10px 16px', fontSize: 13, cursor: 'pointer' }}>
          Ce n'est pas moi — changer d'utilisateur
        </button>
        <div style={{ fontSize: 11, opacity: 0.7, maxWidth: 340 }}>L'heure de début et de reprise est enregistrée par le serveur. Pense à reprendre dès ton retour.</div>
      </div>
    );
  }

  return (
    <>
      <button onClick={() => { setAsk(true); setErr(''); }} title="Je pars en pause"
        style={{ position: 'fixed', left: 12, bottom: 14, zIndex: 900, background: '#1A5276', color: '#fff', border: 'none', borderRadius: 24, padding: '10px 14px', fontSize: 14, fontWeight: 700, boxShadow: '0 3px 12px rgba(0,0,0,.25)', cursor: 'pointer', opacity: 0.92 }}>
        ☕ Pause
      </button>
      {ask && (
        <div onClick={() => !busy && setAsk(false)} style={{ position: 'fixed', inset: 0, zIndex: 9400, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 16, padding: 22, maxWidth: 340, width: '100%', textAlign: 'center', fontFamily: 'inherit' }}>
            <div style={{ fontSize: 40 }}>☕</div>
            <div style={{ fontSize: 17, fontWeight: 800, margin: '6px 0' }}>Tu pars en pause ?</div>
            <div style={{ fontSize: 13, color: '#555' }}>L'heure est enregistrée maintenant. Appuie sur « Je reprends » à ton retour.</div>
            {err && <div style={{ color: '#C0392B', fontSize: 13, marginTop: 8 }}>{err}</div>}
            <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
              <button disabled={busy} onClick={() => setAsk(false)} style={{ flex: 1, padding: 12, borderRadius: 10, border: '1px solid #ddd', background: '#fff', fontSize: 15, cursor: 'pointer' }}>Annuler</button>
              <button disabled={busy} onClick={debut} style={{ flex: 1, padding: 12, borderRadius: 10, border: 'none', background: '#1A5276', color: '#fff', fontSize: 15, fontWeight: 800, cursor: 'pointer' }}>{busy ? '…' : 'Oui, pause'}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
